App.factory('idleModelService', IdleModelService);

function IdleModelService() {
    var serviceObj = {};
    serviceObj.isModelOpen = false;

    return serviceObj;
}